import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CellRenderersService {
    constructor() {
    }

    legalEntity(params): string {
        return params.data.legalEntity ? params.data.legalEntity.name : '';
    }
}
